<ng-template>
  <div
    [@slideContent]="animationState"
    class="options-container"
    [ngClass]="{ 'visual-indicator-options': visualIndicators() }"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
